import { Box, Paper, Typography } from "@mui/material";
import { MOVEMENT_TYPES, MovementTypes } from "constants/index";
import { formatDateOnlyDMY } from "helpers";
import { Movement, Store } from "types";

type Props = {
  movement: Movement;
  stores: Store[];
  movementTypeLabelOverride?: string;
  movementNumberOverride?: string;
};

export default function OperationPrintHeaderDetails({
  movement,
  stores,
  movementTypeLabelOverride,
  movementNumberOverride,
}: Props) {
  const movementTypes = [
    MOVEMENT_TYPES.INCOME,
    MOVEMENT_TYPES.DISCHARGE,
    MOVEMENT_TYPES.ADDITIONAL,
    MOVEMENT_TYPES.PREPARATION,
    MOVEMENT_TYPES.TRANSFER,
    MOVEMENT_TYPES.INCOME_DRAFT,
    MOVEMENT_TYPES.DISCHARGE_DRAFT,
    MOVEMENT_TYPES.PREPARATION_DRAFT,
    MOVEMENT_TYPES.INCOME_ADJUSTMENT,
    MOVEMENT_TYPES.DISCHARGE_ADJUSTMENT,
    MOVEMENT_TYPES.WORK_ORDER,
  ];

  const movementTypeLabel: string | undefined =
    movementTypeLabelOverride ??
    movementTypes.find(
    (mt) => mt.id === movement.movement_type_id
    )?.label;

  const storeLabel: string = movement.store_id == null
  ? "Todos"
  : stores.find((s) => s.id === movement.store_id)?.description || "-";

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
        padding: "1rem",
        border: "1px solid grey",
        borderRadius: "0.5rem",
      }}
    >
      <Box>
        <Typography fontSize={20} variant="body1">
          <b>Movimiento</b>:{" "}
          {movementTypeLabel &&
            movementTypeLabel.charAt(0).toUpperCase() +
              movementTypeLabel.slice(1)}
        </Typography>
        <Typography fontSize={14} variant="body1">
          <b>Fecha:</b> {formatDateOnlyDMY(movement.date)}
        </Typography>
        <Typography fontSize={14} variant="body1">
          <b>Nº:</b> {movementNumberOverride ?? movement.id?.toString() ?? "-"}
        </Typography>
      </Box>
      {movement.movement_type_id !== MovementTypes.Transfer && (
        <Box>
          <Typography fontSize={14} variant="body2">
            <b>Almacén:</b> {storeLabel}
          </Typography>
        </Box>
      )}
    </Paper>
  );
}
